import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Link } from 'react-router';

import { ErrorMessage } from '../components/ErrorMessage';
import { useProject } from '../projects/context';
import { projectKeys, useProjectApi } from '../projects/useProjectApi';

// BuyerMatches: passende Objekte im Bestand zu einem Kaufgesuch (Dominik 14.10.2026) – Zahl mit Suchgebiet, auf Wunsch die
// Liste (beste zuerst: Auftrag, Termin, Akquise, neu; dann Entfernung). Der Makler sieht nur Leads seines Gebiets.
export function BuyerMatches({ requestId }: { requestId: string }) {
  const { project } = useProject();
  const papi = useProjectApi();
  const [shown, setShown] = useState(false);
  const q = useQuery({
    queryKey: projectKeys.buyerMatches(project.id, requestId),
    queryFn: ({ signal }) => papi.buyerRequestMatches(requestId, signal),
    staleTime: 5 * 60_000,
  });
  if (q.isPending) return <p className="muted small">Passende Objekte werden gesucht …</p>;
  if (q.isError) return <ErrorMessage error={q.error} onRetry={() => void q.refetch()} />;
  const m = q.data;
  if (m.total === 0) {
    return <p className="muted small">Im Bestand passt noch kein Objekt{m.area ? ` (Suchgebiet ${m.area})` : ''}.</p>;
  }
  const extra = [m.with_mandate > 0 && `${m.with_mandate} mit Auftrag`, m.with_appointment > 0 && `${m.with_appointment} mit Termin`].filter(Boolean).join(', ');
  return (
    <div className="buyer-matches">
      <p className="buyer-matches-head">
        <strong>
          {m.total === 1 ? '1 passendes Objekt' : `${m.total} passende Objekte`} im Bestand
        </strong>
        {extra && ` (davon ${extra})`} · Suchgebiet {m.area}
        <button type="button" className="btn btn-small btn-ghost" aria-expanded={shown} onClick={() => setShown((v) => !v)}>
          {shown ? 'Ausblenden' : m.total > m.items.length ? `Die besten ${m.items.length} zeigen` : 'Zeigen'}
        </button>
      </p>
      {shown && (
        <ul className="buyer-match-list">
          {m.items.map((x) => (
            <li key={x.lead_id}>
              <Link to={`/p/${project.key}/leads/${x.lead_id}`}>{x.lead_name || 'Lead'}</Link>
              <span className="muted">
                {' '}
                · {[x.postal_code, x.city].filter(Boolean).join(' ')}
                {x.broker_name ? ` · ${x.broker_name}` : ''}
              </span>
              <ul className="tags">
                {x.reasons.map((r) => (
                  <li key={r} className="tag">
                    {r}
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
